


























































import { ILeader } from "@/entities/travel/additions/leader";
import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
const IconCustom = () => import("@/components/lib/IconCustom.vue");

@Component({
  components: {
    IconCustom,
  },
  filters: {
    getNickname(strLink: string): string {
      if (strLink) {
        let cutNickname = strLink.slice(26);

        return "@" + cutNickname;
      } else {
        return "";
      }
    },
  },
})
export default class ExpectedTravel extends Vue {
  @Prop() leaderData!: ILeader;
}
